/* ==========================================================================
   PLEENA · Partículas (tsParticles slim, versión vanilla para Shopify)
   Mismos parámetros que el componente Sparkles de React:
   size, minSize, density, speed, minSpeed, opacity, minOpacity,
   opacitySpeed, direction, color, mousemove, hover, background.
   Se declara con   <div data-pl-particles='{...}'></div>
   ========================================================================== */
(function () {
  if (window.__PLEENA_PARTICLES__) return;
  window.__PLEENA_PARTICLES__ = true;

  var SRC = 'https://cdn.jsdelivr.net/npm/@tsparticles/slim@3.5.0/tsparticles.slim.bundle.min.js';
  var loading = false, ready = false, queue = [];

  function boot(cb) {
    if (ready) return cb();
    queue.push(cb);
    if (loading) return;
    loading = true;
    var s = document.createElement('script');
    s.src = SRC; s.async = true;
    s.onload = function () {
      ready = true;
      var list = queue.splice(0);
      for (var i = 0; i < list.length; i++) { try { list[i](); } catch (e) { console.warn('[pleena]', e); } }
    };
    s.onerror = function () { queue.length = 0; console.warn('[pleena] tsParticles no cargó'); };
    document.head.appendChild(s);
  }

  function num(v, d) { return (typeof v === 'number' && isFinite(v)) ? v : d; }

  function build(d) {
    var size = num(d.size, 2);
    var speed = num(d.speed, 1.2);
    var opacity = num(d.opacity, 0.85);
    return {
      fullScreen: { enable: false },
      background: { color: { value: d.background || 'transparent' } },
      fpsLimit: 60,
      detectRetina: true,
      interactivity: {
        events: {
          onClick: { enable: false },
          onHover: {
            enable: !!d.hover || !!d.mousemove,
            mode: 'grab',
            parallax: { enable: !!d.mousemove, force: num(d.force, 50), smooth: 12 }
          },
          resize: true
        },
        modes: { grab: { distance: 150, links: { opacity: 0.3 } } }
      },
      particles: {
        color: { value: d.color || '#ffffff' },
        shape: { type: 'circle' },
        links: { enable: false },
        number: { value: num(d.density, 70), density: { enable: true, width: 1600, height: 1200 } },
        move: {
          enable: true,
          direction: d.direction || 'none',
          straight: !!d.straight,
          outModes: { default: 'out' },
          speed: { min: num(d.minSpeed, speed / 130), max: speed }
        },
        opacity: {
          value: { min: num(d.minOpacity, opacity / 10), max: opacity },
          animation: { enable: true, sync: false, speed: num(d.opacitySpeed, 3) }
        },
        size: { value: { min: num(d.minSize, size / 1.6), max: size } }
      }
    };
  }

  function init(el) {
    if (el.__plParticles) return;
    el.__plParticles = true;
    var d = {};
    try { d = JSON.parse(el.getAttribute('data-pl-particles') || '{}'); } catch (e) {}
    boot(function () {
      if (!window.tsParticles) return;
      var opts = build(d);
      // load() devuelve una promesa: si falla ahí, el try/catch no la ve.
      function intentar(params) {
        var r;
        try { r = window.tsParticles.load(params); }
        catch (e) { return Promise.reject(e); }
        return (r && r.then) ? r : Promise.resolve(r);
      }
      intentar({ element: el, options: opts })['catch'](function () {
        // respaldo: algunas versiones solo aceptan {id}
        if (!el.id) el.id = 'pl-sparks-' + Math.random().toString(36).slice(2, 9);
        return intentar({ id: el.id, options: opts });
      })['catch'](function (e) {
        console.warn('[pleena] partículas no iniciaron:', e && e.message ? e.message : e);
      });
    });
  }

  // se encienden solo cuando la sección se acerca a la pantalla
  /* cinco canvas con su propio rAF no caben en un telefono: en movil y en
     aparatos flojos las particulas no arrancan, los puntos CSS las sustituyen */
  function permitido() {
    var h = document.documentElement;
    if (h.classList.contains('pl-lowfx') || h.classList.contains('pl-minfx')) return false;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return false;
    if (window.innerWidth < 900) return false;
    try { if (navigator.connection && navigator.connection.saveData) return false; } catch (e) {}
    return true;
  }

  function scan(root) {
    if (!permitido()) return;
    var els = (root || document).querySelectorAll('[data-pl-particles]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.__plParticles) return;
        if (!('IntersectionObserver' in window)) return init(el);
        var io = new IntersectionObserver(function (en) {
          for (var j = 0; j < en.length; j++) {
            if (en[j].isIntersecting) { io.disconnect(); init(el); return; }
          }
        }, { rootMargin: '300px' });
        io.observe(el);
      })(els[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
